import * as Sentry from '@sentry/vue'
import _ from 'lodash'
import { MUTATION_TYPE, ACTION_TYPE, GETTER_TYPE } from './types'
import Api from '@/api/current-user'

export default {
  state: {
    user: null, // текущий юзер системы
    error: null
  },

  mutations: {
    [MUTATION_TYPE.setCurrentUser]: (state, currentUser) => {
      state.user = currentUser
      if (currentUser) {
        Sentry.setUser({
          id: currentUser.id,
          email: currentUser.email,
          surname: currentUser.surname,
          midname: currentUser.midname,
          name: currentUser.name
        })
      } else {
        Sentry.setUser(null)
      }
    },
    [MUTATION_TYPE.setError]: (state, error) => {
      state.error = error
    }
  },

  actions: {
    [ACTION_TYPE.fetchCurrentUser]: ({ commit }) => new Promise((resolve) => {
      commit('setError', null)
      Api.currentUser()
        .then((user) => {
          commit('setCurrentUser', user.data)
          resolve()
        })
        .catch((error) => {
          commit('setCurrentUser', null)
          commit('setError', _.get(error, 'response.data', null))
          resolve()
        })
    }),
    [ACTION_TYPE.signIn]: ({ commit }, formData) => new Promise((resolve) => {
      commit('setError', null)
      Api.signIn(formData)
        .then(() => {
          resolve()
        })
        .catch((error) => {
          commit('setError', error.response.data)
          resolve()
        })
    }),
    [ACTION_TYPE.signOut]: ({ dispatch, commit }) => new Promise((resolve) => {
      commit('setError', null)
      Api.signOut()
        .then(() => {
          dispatch('fetchCurrentUser')
          resolve()
        })
        .catch((error) => {
          commit('setError', error.response.data)
          resolve()
        })
    })
  },

  getters: {
    [GETTER_TYPE.getCurrentUser]: (state) => state.user,
    [GETTER_TYPE.isAuthenticated]: (state) => state.user && !state.error,
    [GETTER_TYPE.getError]: (state) => state.error,
    [GETTER_TYPE.hasRole]: (state) => (roleName) => {
      if (state.user) {
        const { roles } = state.user
        for (const role of roles) {
          if (role.title === roleName) {
            return true
          }
        }
      }
      return false
    }
  }
}
